import React from "react"

import { Choice } from "../../config/story.types"

type Props = {
  choices: Choice[]
  onSelect: (choice: Choice) => void
  disabled?: boolean
}

export default function ChoiceButtons({ choices, onSelect }: Props) {
  return (
    <div className="choices">
      {choices.map(choice => (
        <button key={choice.label} onClick={() => onSelect(choice)}>
          {choice.label}
        </button>
      ))}
    </div>
  )
}
